var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#909398",
    d: "M87.477,0.032H12.524c-6.89,0-12.492,5.603-12.492,12.492v74.953c0,6.889,5.603,12.492,12.492,12.492H50 V65.615H37.507V50H50V37.507c0-10.349,8.389-18.738,18.738-18.738H81.23v15.615h-6.248c-3.445,0-6.244-0.325-6.244,3.123V50 h15.615l-6.246,15.615h-9.369v34.354h18.738c6.889,0,12.492-5.604,12.492-12.492V12.524C99.969,5.634,94.365,0.032,87.477,0.032z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.31d6e51fe28efc2786f6785ab03457d5.svg";
export { ForwardRef as ReactComponent };